import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import generate from 'shortid';
import { Col } from 'reactstrap';

import { TableCell } from '../index';
import './DataTable.scss';

class DataTable extends PureComponent {
  constructor(props) {
    super(props);
    this.renderHeadingRow = this.renderHeadingRow.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  renderHeadingRow(cell, cellIndex) {
    const { headings, columnClasses } = this.props;
    return (
      <TableCell
        key={`heading-${cellIndex}`}
        content={headings[cellIndex].content}
        header
        width={columnClasses[cellIndex]}
        classes={headings[cellIndex].classes}
      />
    );
  }

  renderRow(rowId) {
    const { columnClasses, rows } = this.props;
    return rows.get(rowId).map((cell, index) => (
      <TableCell
        key={`cell-${generate()}`}
        content={cell.content}
        width={columnClasses[index]}
        classes={cell.classes}
      />
    ));
  }

  render() {
    const { headings, rows, rowAction } = this.props;
    const emptyFunction = () => {};
    const rowClick = rowAction || emptyFunction;
    const theadMarkup = (
      <div
        key="heading"
        className="row small bg-gray-50 d-flex font-weight-bold"
        tag="tr"
      >
        {headings.map(this.renderHeadingRow)}
      </div>
    );
    // rows is a Map() so it behaves a little differently than an array.
    // We're disabling a few eslint rules for clarity and because
    // eslint doesn't full understand the data structure
    const tbodyMarkup = [];
    rows.forEach((value, rowId) => {
      tbodyMarkup.push(// eslint-disable-line
        <div
          key={`row-${rowId}`} // eslint-disable-line
          onClick={() => rowClick(rowId)}
          onKeyDown={emptyFunction}
          role="button"
          tabIndex="0"
          className="table-row row"
          tag="tr"
        >
          {this.renderRow(rowId)}
        </div>
      );// eslint-disable-line
    });
    return (
      <div className="table table-hover">
        <Col className="col-sm-12">{theadMarkup}</Col>
        <Col className="col-sm-12 border-bottom">{tbodyMarkup}</Col>
      </div>
    );
  }
}

DataTable.defaultProps = {
  headings: null,
  rows: null,
  rowAction: () => {},
  columnClasses: [''],
};

DataTable.propTypes = {
  headings: PropTypes.arrayOf(PropTypes.shape({
    classes: PropTypes.arrayOf(PropTypes.string),
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]),
  })),
  rows: PropTypes.instanceOf(Map),
  rowAction: PropTypes.func,
  columnClasses: PropTypes.arrayOf(PropTypes.string),
};

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/Table/DataTable.jsx